import script from "./AssessmentGovernanceCommunity.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentGovernanceCommunity.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentGovernanceCommunity.vue?vue&type=style&index=0&id=e0ac3592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0ac3592"]])

export default __exports__